import { cloneElement, ComponentProps, FC } from 'react'

import { clsx } from 'clsx'

import { getValidChildren } from '../utils/index.js'
import { ButtonSize } from './Button.js'

export type ButtonGroupProps = ComponentProps<'div'> & {
  size?: ButtonSize
}

export const ButtonGroup: FC<ButtonGroupProps> = props => {
  const { size = 'md', className, children, ...rest } = props

  const variant = 'outline'

  const validChildren = getValidChildren(children)

  const clones = validChildren.map(child => {
    const childProps = {
      variant,
      size,
      className:
        'rounded-s-none rounded-e-none  first:rounded-s-md last:rounded-e-md -ms-px  focus:z-10',
    }

    return cloneElement(child, childProps)
  })

  return (
    <span
      className={clsx(
        'relative isolate z-0 inline-flex shadow-sm rounded-md',
        className,
      )}
      {...rest}
    >
      {clones}
    </span>
  )
}
